import Quiz from '@crehana/compass.icons.fill/Quiz';
import { cn } from '@crehana/compass.ui/v2';

type TLessonVideoItemProps = {
  title: string;
  className?: string;
};

const LessonQuizItem: React.FC<TLessonVideoItemProps> = ({
  title,
  className,
}) => {
  return (
    <li
      className={cn(
        'tw-flex tw-items-center tw-w-full tw-text-left focus:tw-outline-none',
        className,
      )}
      data-cy="course-lesson"
    >
      <p className="tw-flex tw-gap-1.2 tw-items-center tw-justify-between tw-w-full">
        <Quiz size={16} className="tw-flex-none tw-text-neutral-light-800" />
        <span className="tw-flex-grow tw-font-body5">{title}</span>
      </p>
    </li>
  );
};

export default LessonQuizItem;
